import { render, staticRenderFns } from "./ClassicInfinityDimensionsTab.vue?vue&type=template&id=541f6679&"
import script from "./ClassicInfinityDimensionsTab.vue?vue&type=script&lang=js&"
export * from "./ClassicInfinityDimensionsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports